import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../Pages/Dashboard/Dashboard";
import UserComponent from "../Pages/Configuration/User";
import RolesComponent from "../Pages/Configuration/Role";
import PermissionComponent from "../Pages/Configuration/Permission";
import RoleGroupsComponent from "../Pages/Configuration/RoleGroup";
import MasterTable from "../Pages/Master/MasterTable/MasterTable";
import DepartmentComponent from "../Pages/Configuration/Department";
import DynamicTable1 from "../Pages/Master/DynamicTable/DynamicTable";
import ProfileSetting from "../Pages/Profile/ProfileSetting";
import GlobalSettings from "../Pages/Profile/GlobalSettings";
import DnDFlow from "../Pages/Flow/Flow";
// import EditFlow from "../Pages/Flow/EditFlow";
import EditFlowNewFeature from "../Pages/Flow/EditFlowNewFeature";
import TemplateList from "../Pages/Flow/TemplateList";
import ProtectedRoute from "./ProtectedRoute";
import AssetClass from "../Pages/Assets/AssetClass/AssetClass";
import AssetList from "../Pages/Assets/AssetClass/AssetList";
import EditAsset from "../Pages/Assets/AssetClass/EditAsset";
import ModelClass from "../Pages/Assets/ModelClass/ModelClass";
import ModelList from "../Pages/Assets/ModelClass/ModelList";
import ModelAsset from "../Pages/Assets/ModelClass/EditModel";
import AllAssets from "../Pages/MyAssets/AllAssets";
import AssetAttribute from "../Pages/Assets/AssetAttribute/AssetAttribute";
import EditEquipment from "../Pages/MyAssets/EditEquipment";
import ViewEquipment from "../Pages/MyAssets/ViewEquipment";
import AddEquipments from "../Pages/MyAssets/AddEquipments";
import ListOfAssets from "../Pages/Review/ListOfAssets";
import TagReview from "../Pages/Review/TagReview";
import UsageReview from "../Pages/Review/UsageReview";
import PermissionBasedRoute from "../Services/PermissionBasedRoute";
import Unauthorized from "../Pages/Unauthorized ";
import AllAssetsGroup from "../Pages/MyAssets/AllAssetGroup";
import AddAssetGroup from "../Pages/MyAssets/AddAssetGroup";
import UpdateAssetGroup from "../Pages/MyAssets/EditAssetGroup";
import Notification from "../Pages/Notification/Notification";
import SvpMapping from "../Pages/Review/SvpMapping";
import AssetTagMapping from "../Pages/Review/AssetTagMapping";

const ProtectedRoutes = () => {
  return (
    <Routes>
      <Route path="/unauthorized" element={<Unauthorized />} />{" "}
      {/* Add Unauthorized route */}
      <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
      <Route
        path="/profilesetting"
        element={<ProtectedRoute element={<ProfileSetting />} />}
      />
      <Route
        path="/globalsettings"
        element={<ProtectedRoute element={<GlobalSettings />} />}
      />
      <Route
        path="/users"
        element={
          <PermissionBasedRoute requiredPermissions={["users.view"]}>
            <ProtectedRoute element={<UserComponent />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/roles"
        element={
          <PermissionBasedRoute requiredPermissions={["roles.view"]}>
            <ProtectedRoute element={<RolesComponent />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/rolegroups"
        element={
          <PermissionBasedRoute requiredPermissions={["roleGroups.view"]}>
            <ProtectedRoute element={<RoleGroupsComponent />} />
          </PermissionBasedRoute>
        }
      />
      {/* <Route
          path="/dashboard"
          element={
            <PermissionBasedRoute requiredPermissions={['viewDashboard']}>
              <Dashboard />
            </PermissionBasedRoute>
          }
        /> */}
      <Route
        path="/master"
        element={
          <PermissionBasedRoute requiredPermissions={["masters.view"]}>
            <ProtectedRoute element={<MasterTable />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/department"
        element={
          <PermissionBasedRoute requiredPermissions={["departments.view"]}>
            <ProtectedRoute element={<DepartmentComponent />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/permission"
        element={
          <PermissionBasedRoute requiredPermissions={["permission.view"]}>
            <ProtectedRoute element={<PermissionComponent />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/parameter_types/:id/masters/:masterId"
        element={
          <PermissionBasedRoute requiredPermissions={["parameters.view"]}>
            <ProtectedRoute element={<DynamicTable1 />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/template_types/:template_type_id/create"
        element={
          <PermissionBasedRoute requiredPermissions={["templates.create"]}>
            <ProtectedRoute element={<DnDFlow />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/template_types/:template_type_id/edit/:template_id"
        element={
          <PermissionBasedRoute requiredPermissions={["templates.update"]}>
            <ProtectedRoute element={<EditFlowNewFeature />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/template_types/:id"
        element={
          <PermissionBasedRoute requiredPermissions={["templates.view"]}>
            <ProtectedRoute element={<TemplateList />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/asset_class/create"
        element={
          <PermissionBasedRoute requiredPermissions={["assets.create"]}>
            <ProtectedRoute element={<AssetClass />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/asset_list"
        element={
          <PermissionBasedRoute requiredPermissions={["assets.view"]}>
            <ProtectedRoute element={<AssetList />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/asset/edit/:asset_id"
        element={
          <PermissionBasedRoute requiredPermissions={["assets.update"]}>
            <ProtectedRoute element={<EditAsset />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/model_class/create"
        element={
          <PermissionBasedRoute requiredPermissions={["models.create"]}>
            <ProtectedRoute element={<ModelClass />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/model_list"
        element={
          <PermissionBasedRoute requiredPermissions={["models.view"]}>
            <ProtectedRoute element={<ModelList />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/model/edit/:model_id"
        element={
          <PermissionBasedRoute requiredPermissions={["models.update"]}>
            <ProtectedRoute element={<ModelAsset />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/asset_attribute"
        element={
          <PermissionBasedRoute requiredPermissions={["assets.view"]}>
            <ProtectedRoute element={<AssetAttribute />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/all_assets"
        element={
          <PermissionBasedRoute requiredPermissions={["myAssets.view"]}>
            <ProtectedRoute element={<AllAssets />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/add_equipment"
        element={
          <PermissionBasedRoute requiredPermissions={["myAssets.create"]}>
            <ProtectedRoute element={<AddEquipments />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/edit_equipment/:equipment_id"
        element={
          <PermissionBasedRoute requiredPermissions={["myAssets.update"]}>
            <ProtectedRoute element={<EditEquipment />} />
          </PermissionBasedRoute>
        }
      />
         <Route
        path="/view_equipment/:equipment_id"
        element={
          <PermissionBasedRoute requiredPermissions={["myAssets.update"]}>
            <ProtectedRoute element={<ViewEquipment />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/list_of_assets/:lineage_id"
        element={

          <ProtectedRoute element={<ListOfAssets />} />

        }
      />
      <Route
        path="/tag_review/:lineage_id"
        element={

          <ProtectedRoute element={<TagReview />} />

        }
      />

      <Route
        path="/usecases"
        element={
          <ProtectedRoute element={<UsageReview />} />

        }
      />
      <Route
        path="/spv_mapping"
        element={
          <ProtectedRoute element={<SvpMapping />} />
        }
      />
      <Route
        path="/asset_tag_mapping"
        element={
          <ProtectedRoute element={<AssetTagMapping />} />

        }
      />
      <Route
        path="/all_assets_group"
        element={
          <PermissionBasedRoute requiredPermissions={["assetGroup.view"]}>
            <ProtectedRoute element={<AllAssetsGroup />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/add_asset_group"
        element={
          <PermissionBasedRoute requiredPermissions={["assetGroup.create"]}>
            <ProtectedRoute element={<AddAssetGroup />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/edit_asset_group/:asset_group_id"
        element={
          <PermissionBasedRoute requiredPermissions={["assetGroup.update"]}>
            <ProtectedRoute element={<UpdateAssetGroup />} />
          </PermissionBasedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
            <ProtectedRoute element={<Notification />} />
        }
      />
    </Routes>
  );
};

export default ProtectedRoutes;
